/** Button styles shared by modal footers. */
export const modalButton = {
  primary:
    'px-4 py-2 bg-brand-primary text-white rounded-lg text-sm font-medium hover:bg-brand-dark disabled:opacity-60',
  danger: 'px-4 py-2 bg-danger text-white rounded-lg text-sm font-medium hover:opacity-90 disabled:opacity-60',
  ghost: 'px-3 py-2 text-sm text-gray-500 hover:text-brand-dark',
}
